// Mobile Touch Support for Season Dropdown
document.addEventListener('DOMContentLoaded', function() {
  // Only apply on touch devices
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    const seasonTriggers = document.querySelectorAll('.product-seasons-trigger');
    
    seasonTriggers.forEach(trigger => {
      const label = trigger.querySelector('.season-label');
      
      if (label) {
        // Toggle dropdown on tap
        label.addEventListener('touchstart', function(e) {
          e.preventDefault();
          
          // Close all other dropdowns
          seasonTriggers.forEach(other => {
            if (other !== trigger) {
              other.classList.remove('tapped');
            }
          });
          
          // Toggle this dropdown
          trigger.classList.toggle('tapped');
          
          // Auto-close after 3 seconds
          setTimeout(() => {
            trigger.classList.remove('tapped');
          }, 3000);
        });
      }
    });
    
    // Close dropdown when tapping outside
    document.addEventListener('touchstart', function(e) {
      if (!e.target.closest('.product-seasons-trigger')) {
        seasonTriggers.forEach(trigger => {
          trigger.classList.remove('tapped');
        });
      }
    });
  }
});